import { IntlFormatters, FormatDateOptions } from "react-intl";

interface Opts {
  date?: boolean;
  time?: boolean;
  dateConfig?: FormatDateOptions;
  timeConfig?: FormatDateOptions;
}

export default (
  timestamp: number | undefined,
  intl: IntlFormatters,
  { date = true, time = true, dateConfig = {}, timeConfig = { hourCycle: "h23" } }: Opts = {}
): string => {
  if (!timestamp) return "";
  const val = timestamp * 1000;
  const convertedTime = intl.formatTime(val, timeConfig);
  const convertedDate = intl.formatDate(val, dateConfig);
  if (!date) return convertedTime;
  if (!time) return convertedDate;
  return `${convertedDate} ${convertedTime}`;
};
